<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @exportData="exportFile"
        @clearCheckboxRow="clearCheckboxRow"
        :checkedCount="checkedCount"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'admin-sampleBorrow' }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
      @export-success="clearCheckboxRow"
    />
  </div>
</template>
<script>
import ChooseTemplate from '../choose-template'
import PageMain from './main.vue'
import PageHeader from './header.vue'
import BaseTable from '@/mixins/base-table'
export default {
  components: { PageMain, PageHeader, ChooseTemplate },
  mixins: [BaseTable],
  data() {
    return {
      loading: false,
      usePage: true,
      checkedRow: [],
      currSearchForm: {},
      chooseTemplateOptions: { visible: false },
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .billStockBorrowMainStatisticsListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.currSearchForm = form
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearCheckboxRow() {
      this.checkedRow = []
      this.$refs.main.clearCheckboxRow()
    },
    exportFile() {
      const detailCodes = this.checkedRow?.map((item) => item.detailCode) || []
      const searchForm = {
        ...this.currSearchForm,
        detailCodes,
      }

      this.chooseTemplateOptions = { visible: true, searchForm }
    },
  },
}
</script>
